import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const stats = [
  { value: "$126B+", label: "Māori Economy" },
  { value: "100K+", label: "Network Partners" },
  { value: "5", label: "Directors, Five Regions" },
  { value: "3", label: "Domains: People, Place, Planet" },
];

export default function ImpactNumbers() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <div
      ref={ref}
      data-testid="impact-numbers"
      className="py-10 sm:py-12"
      style={{ background: "linear-gradient(90deg, #bb321a, #485e23, #364225)" }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="text-center"
            >
              <p className="font-['Syne'] text-3xl sm:text-4xl lg:text-5xl font-black text-white">{stat.value}</p>
              <p className="text-xs sm:text-sm text-white/70 uppercase tracking-wider mt-1 font-semibold">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
